<template>
  <div id="vehicles" class="flex column wrap justify-center grow-1">
    <h2 class="title">LISTADO DE VEHÍCULOS</h2>
    <div class="flex justify-space-between column-sm justify-space-between-m">
      <CEAvailableBalanceCard />
      <PersonalInformation />
      <BillingInformation />
    </div>
    <CarRow
      v-for="car in vehicles"
      :key="car.id"
      :car="car"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BillingInformation from '@/components/Vehicles/BillingInformation'
import CEAvailableBalanceCard from '@/components/CEAvailableBalanceCard'
import CarRow from '@/components/Vehicles/CarRow'
import PersonalInformation from '@/components/Vehicles/PersonalInformation'

export default {
  name: 'CEVehicles',
  components: {
    CEAvailableBalanceCard,
    BillingInformation,
    CarRow,
    PersonalInformation
  },
  computed: {
    ...mapGetters([
      'vehicles'
    ])
  },
  methods: {
    ...mapActions('vehicles', [
      'getVehiclesList'
    ])
  },
  beforeMount: function () {
    this.getVehiclesList()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#vehicles {
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color:$grey;
}
</style>
